<div class="tutorization--block__column">
  <div *ngIf="stats" class="tutorization--block__row">
    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.totalDebates' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">{{ stats.totalDebates }}</div>
        <div class="dashboard-card-item-label">{{ 'debates.widgets.debates' | translate }}</div>
      </div>
    </div>

    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.meanVotesDebates' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">
          {{ stats.totalDebates ? stats.totalVotes / stats.totalDebates : 0 }}
        </div>
        <div class="dashboard-card-item-label">{{ 'debates.widgets.votes' | translate }}</div>
      </div>
    </div>

    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.certifiedDebates' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">{{ stats.totalCertified }}</div>
        <div class="dashboard-card-item-label">{{ 'debates.widgets.debates' | translate }}</div>
      </div>
    </div>

    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.cancelled' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">{{ stats.totalCancelled }}</div>
        <div class="dashboard-card-item-label">{{ 'debates.widgets.debates' | translate }}</div>
      </div>
    </div>
  </div>

  <lms-list
    [listId]="listId"
    [serviceProvider]="debatesService"
    (collectionUpdated)="setCollection($event)"
    [options]="options"
  >
    <div class="table-heading">
      <lms-list-header
        [listId]="listId"
        class="table-item"
        field="questionTitle"
        label="debates.label"
      ></lms-list-header>
      <lms-list-header [listId]="listId" class="table-item" field="session" label="debates.seasons"></lms-list-header>
      <lms-list-header
        [listId]="listId"
        class="table-item"
        field="votes.positive"
        label="debates.votes"
      ></lms-list-header>
      <lms-list-header
        [listId]="listId"
        class="table-item"
        field="created_at"
        label="debates.opinions"
      ></lms-list-header>
      <lms-list-header
        [listId]="listId"
        class="table-item"
        field="status"
        label="debates.statusLabel"
      ></lms-list-header>
      <div class="table-item"></div>
    </div>
    <lms-mars1-debate-row *ngFor="let debate of debates" [debate]="debate"></lms-mars1-debate-row>
  </lms-list>
</div>
